export default __webpack_public_path__ + "static/media/open_sp_ticket.a75a1014.svg";